class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    const cartDrawerSection = document.querySelector(".cart-drawer-section");
    const shopifySection = JSON.parse(cartDrawerSection.getAttribute("data-shopify-editor-section"));
    document.addEventListener("shopify:section:select", function (event) {
      if (event.detail.sectionId === shopifySection.id) {
        console.log("Cart Drawer section selected.");
        setTimeout(() => {
          this.classList.add("animate", "active");
        });
      }
    });

    document.addEventListener("shopify:section:deselect", function (event) {
      if (event.detail.sectionId === shopifySection.id) {
        console.log("Cart Drawer section deselected.");
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log("open");
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    const reward_price_block = document.querySelector(".jc-price-reward");
    reward_price_block.style.width = document.oldRewardPercentage + "%";
    const percent_price = 100 - reward_price_block.dataset.reward;
    setTimeout(() => {
      reward_price_block.style.width = percent_price + "%";
    }, 500);
    document.oldRewardPercentage = percent_price;
    document.body.classList.add("overflow-hidden");
  }

  close() {
    console.log("close");
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    const oldItemCount = this.querySelector(".drawer__heading").dataset.itemCount;
    let jollyModalProduct = document.querySelector("jolly-modal-product");

    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    console.log("this.getSectionsToRender()", this.getSectionsToRender());
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      let html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      const domparser = new DOMParser();
      const cartDom = domparser.parseFromString(html, "text/html");

      console.log(sectionElement);
      /* const old_reward_price_block = cartDom.querySelector(".jc-price-reward");
      if (old_reward_price_block) {
        old_reward_price_block.style.width = document.oldRewardPercentage + "%";
      } */
      sectionElement.innerHTML = cartDom.documentElement.innerHTML;
    });

    const newItemCount = this.querySelector(".drawer__heading").dataset.itemCount;

    if (newItemCount - oldItemCount > 0) {
      //this.querySelector('.drawer__heading .jc-item-count').innerText = `${newItemCount - oldItemCount}`;
      this.querySelector(".drawer__header").style.height = "60px";
      this.querySelector(".drawer__heading").style.top = "20px";
      setTimeout(() => {
        this.querySelector(".drawer__header").style.height = "0px";
        this.querySelector(".drawer__heading").style.top = "-35px";
      }, 3000);
    }

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      document.dispatchEvent(new CustomEvent("jc-cart:reload"));

      if (this.querySelector(".cart-drawer").dataset.openCart == "true") {
        this.open();
      }

      jollyModalProduct.classList.remove("jc-translate-y-0");
      jollyModalProduct.classList.add("jc-translate-y-full");

      const modalShadow = document.getElementById("jc-modal-shadow");
      if (modalShadow) {
        modalShadow.classList.add("jc-hidden");
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer-items",
        section: "cart-drawer-items",
        selector: ".cart-drawer-items",
      },
      {
        id: "cart-drawer-reward",
        section: "cart-drawer-reward",
        selector: ".cart-drawer-reward",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-bubble",
      },
      {
        id: "cart-drawer-footer",
        section: "cart-drawer-footer",
        selector: ".drawer__footer",
      },
      {
        id: "cart-upsell-recommendation",
        section: "cart-upsell-recommendation",
        selector: ".cart-upsell-recommendation",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer-items",
        section: "cart-drawer-items",
        selector: ".shopify-section",
      },
      {
        id: "cart-drawer-reward",
        section: "cart-drawer-reward",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-bubble",
      },
      {
        id: "cart-drawer-footer",
        section: "cart-drawer-footer",
        selector: ".drawer__footer",
      },
      {
        id: "cart-upsell-recommendation",
        section: "cart-upsell-recommendation",
        selector: ".cart-upsell-recommendation",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
